import React from "react";
import './App.css';
import { NavLink } from "react-router-dom";
/*import { NavDropdown, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';*/
import { useState, useEffect } from 'react';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";


function NavBar() {
    const [account, setAccount] = useState("Account");
    const [direct, setDirect] = useState("/signin");

    let login = false;
    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                login = true;
                setAccount("Dashboard");
                setDirect("/dashboard");
            } else {
                login = false;
            }
        });
    });

    return (
        <div>
            <nav className="fixed top-0 left-0 right-0 z-50 bg-ddp py-7 sm:px-24 py-3 flex justify-center">
                <NavLink className="navbar-brand transition" to="/">
                    <div className="">
                        <div className="">
                            <span className="text-sm md:text-xl text-white hover:text-lightp transition duration-20">Home</span>
                        </div>
                    </div>
                </NavLink>
                <ul className="ml-auto flex justify-center">
                    <li className="nav-item mr-10">
                        <NavLink className="navbar-brand transition" to="/explore">
                            <span className="text-sm md:text-xl text-white hover:text-lightp transition duration-20">Explore</span>
                        </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="navbar-brand transition" to="/discord">
                            <span className="text-sm md:text-xl text-white hover:text-lightp transition duration-20">Discord</span>
                        </NavLink>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

/*
to={direct}
{account}
*/

export default NavBar;